import React from 'react'
import styles from "../styles/Home.module.scss";
import ReactPlayer from 'react-player/lazy'
import { isMobile } from 'react-device-detect';
import { useMediaQuery } from 'react-responsive';


const ExploreSection = (props) => {
  const { backgroundImg, 
    headerText1, 
    headerText2,
    text1,
    text2,
    backgroundDesktop,
    backgroundMobile
     } = props;

  const isWideWidth = useMediaQuery({
    query: '(min-width: 1025px)'
  })

  const DesktopRender = () => {
    return (
      <div>
      { isWideWidth ? 
   
        <div className={styles.section} >
          <div className={styles.container}>
        <img className={styles.floatingImg} src={backgroundMobile} alt="explore" />
        <div className={styles.contentExploreWrapper}>
          <div className={styles.exploreContent}>
            <div className={styles.leftContent}>
              <ReactPlayer  
                className={styles.contentImage}
                  width='100%'
                  height='100%'
                  playing={true}
                  loop={true}
                  muted={true}
                  url={backgroundDesktop} />
            </div>
            <div className={styles.rightContent}>
              <div className={styles.items}>
                <h1>{headerText1}</h1>
                <p className={styles.leftContentText}>{text1}</p>
                <h1>{headerText2}</h1>
                <p className={styles.leftContentText}>{text2}</p>
              </div>
            </div>
          </div> 
        </div>
        </div>
        </div>
      :
      <div className={styles.exploreWrapper}>
        <div> 
          <img src={backgroundMobile} alt="explore" />
        </div>
        <div className={styles.exploreContent}>
            <div className={styles.items}>
              <h1>{headerText1}</h1>
              <p className={styles.leftContentText}>{text1}</p>
              <h1>{headerText2}</h1>
              <p className={styles.leftContentText}>{text2}</p>
            </div>
          </div>

         <ReactPlayer  
            className={styles.contentImage}
            width='100%'
            height='100%'
            playing={true}
            loop={true}
            muted={true}
            url={backgroundDesktop} />
     </div>        
      }
      </div>
    )
  }

  const MobileRender = () => {
    return (
      <div className={styles.mobileExplore}>
        <div className={styles.mobileContainer}>
          <div className={styles.mobileImgContainer}>
            <img className={styles.mobileImg}src={backgroundMobile} alt="explore"/>
          </div>
        </div>
        <div className={styles.mobileText}>
            <h1>{headerText1}</h1>
            <p className={styles.leftContentText}>{text1}</p>
            <h1>{headerText2}</h1>
            <p className={styles.leftContentText}>{text2}</p>
          </div>
      </div>
    )
  } 
  return (
    <>
      {!isMobile && <DesktopRender />}
      {isMobile && <MobileRender />}

    </>
  )
  
}

export default ExploreSection
